module.exports = __webpack_public_path__ + "static/media/hero_mobile.fece211d.webp";